import { Select, Slider, Button } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

export default function MenuComponent({
  tipoMapa,
  setTipoMapa,
  regiones,
  setRegionSelect,
  dataProyectada,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "36px",
        alignItems: "center",
        padding: "12px",
      }}
    >
      <Select
        defaultValue="País"
        style={{
          width: "100%",
          maxWidth: "100px",
        }}
        onChange={(val) => setTipoMapa(val)}
        options={[
          {
            value: "País",
            label: "País",
          },
          {
            value: "Regional",
            label: "Regional",
          },
        ]}
      />

      <Select
        defaultValue={regiones[0]}
        style={{
          width: "100%",
          maxWidth: "250px",
        }}
        onChange={(val) => setRegionSelect(val)}
        options={regiones.map((el) => {
          return { value: el, label: el };
        })}
        disabled={tipoMapa === "País"}
      />

      <div
      >   
      </div>
    </div>
  );
}
